import { AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./actions";
import * as actionTypes from "./actionTypes";
import * as types from "./types";
import * as services from "./service";


function* fetchProfileSaga(action: types.IFetchProfileRequest) {
    try {
        const response: AxiosResponse<types.IProfile[]> = yield call(services.getProfile, action.params);

        yield put(
            actions.fetchProfileSuccess({
                profile: response.data,
            })
        );
    } catch (e: any) {
        yield put(
            actions.fetchProfileFailure({
                error: e.message,
            })
        );
    }
}

/*
Watcher saga - intercept the action fired from view
Starts worker saga on latest dispatched `FETCH_ACCESSCONTROL_REQUEST` action.
Allows concurrent increments.
*/
function* getProfileSaga() {
    yield takeLatest(actionTypes.FETCH_PROFILE_REQUEST, fetchProfileSaga);
}

function* profileSaga() {
    yield all([
        getProfileSaga(),
    ])
};

export default profileSaga;
